export const PartnerSafeApi=process.env.REACT_APP_PTN_SAFE_API_URL
?? (() => { throw new Error('REACT_APP_PTN_SAFE_API_URL is not defined'); })()
